import dayjs from "dayjs";
import { useEffect } from "react";
import { DecimalHelper } from "@/helpers";
import { useMessage } from "@/contexts";
import { useAppDispatch, useAppSelector } from "@/stores";
import {
  TransferRead,
  TransferHelper,
  TransferService,
  TransferSelfWithdrawStatusText,
  TransferClassHelper,
} from "@/domains/transfer";
import { tenantSelfWithdrawSelects, tenantSelfWithdrawThunks } from "./store";
// components
import { Button, Modal, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { TableTopFilters } from "./TableTopFilters";

export const TenantSelfWithdrawListPage = () => {
  const dispatch = useAppDispatch();

  const loading = useAppSelector(tenantSelfWithdrawSelects.loading);

  const queryParams = useAppSelector(tenantSelfWithdrawSelects.queryParams);

  const transfers = useAppSelector(tenantSelfWithdrawSelects.transfers);

  const { messageApi } = useMessage();

  useEffect(() => {
    void dispatch(tenantSelfWithdrawThunks.list(queryParams));
  }, [dispatch, queryParams]);

  const getRowClassName = (record: TransferRead) => {
    if (TransferHelper.isInvalid(record.status)) {
      return "fg:disabled";
    }
    return "";
  };

  const handleDestroy = (transferId: string) => {
    Modal.confirm({
      title: "確定要作廢此存單嗎？",
      icon: <ExclamationCircleFilled />,
      okType: "danger",
      async onOk() {
        await TransferService.destroy(transferId).run();
        void dispatch(tenantSelfWithdrawThunks.list(queryParams));
        void messageApi.success("訂單已作廢！");
      },
    });
  };

  const columns: ColumnsType<TransferRead> = [
    {
      width: 164,
      title: "單號",
      dataIndex: "id",
    },
    {
      width: 320,
      title: "下發地址",
      key: "address",
      render(_, { target }) {
        return <div>{target?.address}</div>;
      },
    },
    {
      title: "下發點數",
      key: "amount",
      render(_, { amount }) {
        return <div className="t:right">{DecimalHelper.locale(amount)}</div>;
      },
    },
    {
      title: "下發通道",
      dataIndex: "currency",
    },
    {
      title: "手續費",
      key: "charge",
      render(_, { charge }) {
        return <div className="t:right">{DecimalHelper.locale(charge)}</div>;
      },
    },
    {
      title: "備註",
      dataIndex: "note",
    },
    {
      width: 90,
      align: "right",
      className: "v:top px:6!:is(td)",
      title: "申請時間",
      key: "created_at",
      sorter: () => 1,
      render(_, { created_at }) {
        return <div>{dayjs.$ldts(created_at)}</div>;
      },
    },
    {
      width: 90,
      align: "right",
      className: "v:top px:6!:is(td)",
      title: "檢核時間",
      key: "checked_at",
      sorter: () => 1,
      render(_, { checked_at }) {
        return checked_at ? <div>{dayjs.$ldts(checked_at)}</div> : null;
      },
    },
    {
      width: 90,
      align: "right",
      className: "v:top px:6!:is(td)",
      title: "到帳時間",
      key: "arrived_at",
      sorter: () => 1,
      render(_, { arrived_at }) {
        return <div>{dayjs.$ldts(arrived_at)}</div>;
      },
    },
    {
      width: 60,
      title: "狀態",
      key: "status",
      render(_, record) {
        return (
          <div className={TransferClassHelper.getStatusColor(record.status)}>
            {record.transaction ? (
              <a
                target="_blank"
                href={TransferHelper.getTransactionLink(record.transaction)}
              >
                {TransferSelfWithdrawStatusText[record.status]}
              </a>
            ) : (
              TransferSelfWithdrawStatusText[record.status]
            )}
          </div>
        );
      },
    },
    {
      title: "",
      key: "action",
      render(_, { id, status }) {
        if (TransferHelper.isCreated(status)) {
          return (
            <Button danger type="primary" onClick={() => handleDestroy(id)}>
              作廢
            </Button>
          );
        } else return <div />;
      },
    },
  ];

  return (
    <div className="flex flex:col">
      <TableTopFilters />

      <Table
        rowKey="id"
        tableLayout="fixed"
        loading={loading}
        columns={columns}
        dataSource={transfers}
        scroll={{ x: "1600px" }}
        rowClassName={getRowClassName}
      ></Table>
    </div>
  );
};
